export const frontendURI = '/cat/companies/';
export const backendURI = `/api${frontendURI}`;
